/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Quoclvv1 (quoclvv1@rsupport.com)
 *
 * @description
 *
 * @created at Tue Jul 16 2024
 **/

import { useEventHandler } from "@rfice/eventhandler";

import { JotaiStore } from "@/frameworks/libraries/commons";
import { EventID } from "frameworks/core/commons";
import { useAtomCallback } from "jotai/utils";
import { ConferenceIDAtom, MeetingStartTime, ScheduleIDAtom } from "./atom";

export default function OpenMeetingDetail() {
	const handleOpenMeetingDetail = useAtomCallback(
		(_, set, args: { scheduleId?: string; conferenceId?: string; scheduleStartTime?: number }) => {
			set(ConferenceIDAtom, args.conferenceId || "");
			set(ScheduleIDAtom, args.scheduleId || "");
			set(MeetingStartTime, args.scheduleStartTime || null);
		},
		{
			store: JotaiStore
		}
	);

	useEventHandler(EventID.OPEN_MEETING_DETAIL, handleOpenMeetingDetail, []);

	return null;
}
